export default class ScreenWake {
  wakeLock = null

  isSupported() {
    return "wakeLock" in navigator
  }

  async enable() {
    if (this.isSupported()) {
      this.wakeLock = await navigator.wakeLock.request("screen")
    } else {
      this.wakeLock = null
    }
  }

  async disable() {
    if (this.wakeLock) {
      await this.wakeLock.release()
      this.wakeLock = null
    }
  }
}
